import { render } from "./RondleidingButton.vue?vue&type=template&id=e6fbf76a"
import script from "./RondleidingButton.vue?vue&type=script&lang=js"
export * from "./RondleidingButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__